import React from 'react';

interface TransactionFiltersProps {
    dateRange: { start: Date | null; end: Date | null };
    setDateRange: (range: { start: Date | null; end: Date | null }) => void;
    searchTerm: string;
    setSearchTerm: (term: string) => void;
}

const TransactionFilters: React.FC<TransactionFiltersProps> = ({
    dateRange,
    setDateRange,
    searchTerm,
    setSearchTerm
}) => {
    const handleDateChange = (type: 'start' | 'end', value: string) => {
        const date = value ? new Date(value) : null;
        setDateRange({
            ...dateRange,
            [type]: date
        });
    };

    const formatDateForInput = (date: Date | null) => {
        if (!date) return '';
        return date.toISOString().split('T')[0];
    };

    return (
        <div className="bg-white rounded-lg shadow-sm p-4 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                {/* Search */}
                <div className="md:col-span-1">
                    <label className="block text-sm font-medium text-text-heading mb-1">
                        Search
                    </label>
                    <div className="relative">
                        <input
                            type="text"
                            placeholder="Search by plan, type, or prompt..."
                            className="w-full pl-10 pr-4 py-2 rounded-lg border"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                        <i className="fas fa-search absolute left-3 top-3 text-text-description"></i>
                    </div>
                </div>

                {/* Date Range */}
                <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-text-heading mb-1">
                        Date Range
                    </label>
                    <div className="flex flex-col sm:flex-row gap-2">
                        <div className="flex-1">
                            <input
                                type="date"
                                className="w-full px-4 py-2 border rounded-lg"
                                value={formatDateForInput(dateRange.start)}
                                onChange={(e) => handleDateChange('start', e.target.value)}
                                placeholder="Start date"
                            />
                        </div>
                        <div className="flex items-center justify-center px-2">
                            <span className="text-text-description">to</span>
                        </div>
                        <div className="flex-1">
                            <input
                                type="date"
                                className="w-full px-4 py-2 border border-accent-taupe rounded-lg"
                                value={formatDateForInput(dateRange.end)}
                                onChange={(e) => handleDateChange('end', e.target.value)}
                                placeholder="End date"
                            />
                        </div>
                        {(dateRange.start || dateRange.end || searchTerm) && (
                            <button
                                onClick={() => {
                                    setDateRange({ start: null, end: null });
                                    setSearchTerm('');
                                }}
                                className="px-4 py-2 text-sm text-text-description hover:text-text-heading transition-colors"
                            >
                                Clear
                            </button>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TransactionFilters; 